import { Defaults } from "@/common/utils";
import { Table } from "@tanstack/react-table";
import { ChevronDown, ChevronFirst, ChevronLast, ChevronLeft, ChevronRight, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Ticket } from "Stores/dashboardStore/tickets";

interface PagePaginationProps {
	table: Table<Ticket>
	totalPages: number;
	page: number;
	pageSize: number;
	setCurrentPage: (page: number) => void
    setPageSize: (pgSize: number) => void
}

export default function PagePagination({
	totalPages,
	page,
	pageSize,
	setCurrentPage,
	setPageSize,
	table
	}: PagePaginationProps) {
    const [showDropdown, setShowDropdown] = useState(false);

    return (
        <div className="pagination-container">
            <Dropdown show={showDropdown} onToggle={() => setShowDropdown((prev) => !prev)}>
                <Dropdown.Toggle className="d-flex align-items-center gap-2">
					<strong>{pageSize}</strong> per page
					{showDropdown ? <ChevronUp /> : <ChevronDown />}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {Defaults.tablePageSizeOpts().map((option) => (
                        <Dropdown.Item key={option} onClick={() => setPageSize(option)}>
                            {option} per page
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <div className="pagination-buttons">
				<Button
					variant="outline-light"
					onClick={() => { table.setPageIndex(0), setCurrentPage(0) }}
					disabled={page === 0}
				>
                    <ChevronFirst />
				</Button>
				
				<Button
					variant="outline-light"
					onClick={() => { table.previousPage(), setCurrentPage(page - 1) }}
					disabled={page === 0}
				>
                    <ChevronLeft />
                </Button>
				<Button
					variant="outline-light"
					onClick={() => { table.nextPage(), setCurrentPage(page + 1) }}
					disabled={page >= totalPages - 1}
				>
                    <ChevronRight />
				</Button>
				
				<Button
					variant="outline-light"
					onClick={() => setCurrentPage(totalPages - 1)}
					disabled={page >= totalPages - 1}
				>
                    <ChevronLast />
                </Button>
            </div>
        </div>
    );
}
